import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { BookmarkQuestionAttempt, Bookmark_QB, Question_Bookmark, Report_Submit, Result_Submit } from "../../gql/mutation";
import { GET_Instrucation_QB, GetQuestionBookmarks, Get_test } from "../../gql/queries";
import moment from "moment";
import { getQbProgressPercentage } from "../../utils";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
const INITIAL_STATE = {
    contentType: "",
    userFeedBack:"",
    category:"",
    contentId:''
};
export default function MyQuestionBookmarksViewAllSolution () {
    let { id,name,indexs } = useParams()
    const navigate = useNavigate();
    let location = useLocation();
    const REACT_APP_ImageURL = 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'
    let questionAttempt = JSON.parse(localStorage.getItem('bookmarkAttempt')) ? JSON.parse(localStorage.getItem('bookmarkAttempt')) : []; ;   // all attempted questions
    let [localAttemtedQuestions,setLocalAttempt] = useState(questionAttempt);   // all attempted questions
    const [config, setConfig] = useState();
    const [enable,setDisabled] = useState(true)
    const [hashconfig, setHashConfig] = useState();
	const [remoteLoading, setRemoteLoading] = useState(true);
    const [page,setPage]=useState(JSON.parse(localStorage.getItem('activePage')))
    const [index, setIndex] = useState(parseInt(0));
    let [data, setData] = useState(JSON.parse(location.state));
    const [isView, setView] = useState(localAttemtedQuestions[index]!==undefined?true:false);
    const [toogleStatus, setToogleStatus] = useState(JSON.parse(localStorage.getItem('bookmarkStatus')));
	const[course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getDetails, Details] = useState(INITIAL_STATE);
    const [infoShow, setInfo] = useState(false);
    const [imgPopup, setImgPopup] = useState(false);
    const [showImg, setShowImg] = useState();
    const [counter,setCounter]=useState(0)
    let subarr=[]
    let subjects=[]
    let subjectArr=localStorage.getItem('subjectid')?localStorage.getItem('subjectid'):[]
    if(subjectArr.length!=0){
        subjects= subjectArr.split(',')
        for(let i=0;i<subjects.length;i++){
            subarr.push(subjects[i])
        }
    }
    let topicarr=[]
    let topicArr=localStorage.getItem('topicid')?localStorage.getItem('topicid'):[]
    let topics=[]
    if(topicArr.length!=0){
    topics= topicArr.split(',')
    for(let i=0;i<topics.length;i++){
        topicarr.push(topics[i])
    }
    }
    const infoDetailShow = () => setInfo(true);
    const infoDetailhide = () => setInfo(false);
    const showPopupImg = (d) => {
        setImgPopup(true);
        setShowImg(d);
    };
    const imgHide = () => setImgPopup(false);
   
    const [report] = useMutation(Report_Submit)
    useEffect(() => {
        const getHashConfigData = async () => {
            try {
                const remoteData = await firebaseData('hashtag_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setHashConfig(JSON.parse(remoteData));
                // setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                // setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getHashConfigData();
        }
    }, []);
    const backArrowSubmit = () =>{
        let questionArray = [];
        let questions = JSON.parse(localStorage.getItem('bookmarkAttempt'))
        if(questions){
            questions.map((obj,i)=>{
                if(obj!=null){
                    let data = {
                        questionId: obj.questionId,
                        userAnswer: obj.userAnswer
                    }
                    questionArray.push(data);
                }
            })
            resultSubmit({ variables: { upsertAnswerBookmarkInput: questionArray } })
            navigate(`/account/mybookmarks`);
            console.log(questionArray, "list of ques");
        }
        else{
            navigate(`/account/mybookmarks`);
        }
    }
    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function () {
        backArrowSubmit()
        window.history.pushState(null, null, window.location.href);
        };
    }, []);


   

      useEffect(() => {
        const unloadCallback = (event) => {
          event.preventDefault();
          event.returnValue = "";
          return "";
        };
      
        window.addEventListener("beforeunload", unloadCallback);
        return () => window.removeEventListener("beforeunload", unloadCallback);
      }, []);
      
    useEffect(() => {
		const getConfigData = async () => {
		  try {
			const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
            setConfig(JSON.parse(remoteData));
			setRemoteLoading(false);
		  } catch (error) {
			console.error('Error fetching remote data:', error);
			setRemoteLoading(false);
		  }
		};
	
		if (typeof window !== 'undefined') {
		  getConfigData();
		}
	  }, []);
      const [resultSubmit] = useMutation(BookmarkQuestionAttempt);

    const selectedAnswer = (userAnswer,questionId,answer, review) => {
        const data = {
            "questionId": questionId,
            "userAnswer": userAnswer,
            "answer":answer,
            "isReview": review,
        }
        localAttemtedQuestions[index]=(data)
        localStorage.setItem("bookmarkAttempt", JSON.stringify(localAttemtedQuestions));
        setCounter(counter+1)
        setLocalAttempt(localAttemtedQuestions)
        setView(true)
    }
    const query1 = useQuery(GetQuestionBookmarks, {
        variables: {
            "page": page,
            "courseName": course.preparingFor,
            "perPage": 10,
            "subjectIds": subarr?subarr:[],
            "topicIds": topicarr?topicarr:[],
        }
    });
    useEffect(() => {
        const fetchData = async () => {
          if (data == undefined || data == null || data === '') {
            try {
                navigate(`/account/mybookmarks`)
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        }; 
        fetchData();
      }, [query1?.data]);
    if (query1.loading) {return (<><Loader/></>)}
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
            } else {
              return (<>
                <div className="main_wrapper">
                          <div className="col-lg-12">
                              <SomethingWentWrong pathName={location.pathname}/>
                          </div>
                          </div>
                  </>)
            }
            }
    // let arr=[]
    //     query1.data.test.progress.questions.map(obj=>{
    //         if(obj.questionId===data[index]._id){
    //             arr.push(obj.userAnswer)
    //         }
    //     })

    //     let testarr=[]
    //     query1.data.test.progress.questions.map(obj=>{
    //         if(obj.questionId===data[index]._id){
    //             testarr.push(obj.userAnswer)
    //         }
    //     })
    
    const pre = () => {
        if (index > 0) {
            let preIndex = index - 1
            setIndex(preIndex);
        }
    }
    const next = (index) => {
        if(data.length!==query1.data.questionBookMarks.itemCount ){
            if(index ===(data.length)-2){
                setData([])
                query1.fetchMore({
                    variables: { 
                    "page": page+1,
                    "courseName": course.preparingFor,
                    "perPage": 10,
                    "subjectIds": subarr?subarr:[],
                    "topicIds": topicarr?topicarr:[]
                    },
                    
                    // concatenate old and new entries
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                       const newEntries = [...data,...fetchMoreResult.questionBookMarks.questionBookMarks];
                        setData(newEntries)
                    },
                  });
                setPage(page+1)
                localStorage.setItem('activePage',page+1)
                let nextIndex = index + 1
                setIndex(nextIndex);
         }
         else{
             if(index<data.length){
                 let nextIndex = index + 1
                 setIndex(nextIndex);
             }
         }
        }
        else{
            if(index<data.length){
                let nextIndex = index + 1
                setIndex(nextIndex);
            }
        }
    }
   
    const copytext = async(e)=>{
        navigator.clipboard.writeText(data&&data[index]?.question.questionCode)
        toast.success('Copied Success')
    }
    const testcopytext = async(e)=>{
        navigator.clipboard.writeText(data&&data[index]?.testQuestion.questionCode)
        toast.success('Copied Success')
    }
    const handleInputChange = function (fieldValue, fieldName) {
        if(data[index]?.testQuestion==null){
        getDetails.contentType="Qb"
        }else{
        getDetails.contentType="Test"   
        }
        Details({ ...getDetails, [fieldName]: fieldValue })
        if (!fieldValue) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        getDetails.contentId=data&&data[index]._id
        report({variables: {addReportInput:getDetails}}).then(res=>{
            if(res.data.addUserReport.userId){
                Details(INITIAL_STATE)
                setInfo(false)
                toast.success('Report Successful Submitted')
            }
        }).catch(res=>{
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
        }

        const questionImagePlaceholders = (htmlContent) => {
            const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
            return modifiedHtmlContent;
          };

        const removeImagePlaceholders  = (htmlContent) => {
            const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
            return modifiedHtmlContent;
          };
          
              let questionoriginalHtml =  data&&data[index]?.testQuestion==null ?data&&data[index]?.question?.question?.questionText:data&&data[index]?.testQuestion?.question?.questionText
              let questionmodifiedHtml = questionImagePlaceholders(questionoriginalHtml);
    
              let solutionoriginalHtml =  data&&data[index]?.testQuestion==null ?data&&data[index]?.question?.solution?.solutionText:data&&data[index]?.testQuestion?.solution?.solutionText
              let solutionmodifiedHtml = removeImagePlaceholders(solutionoriginalHtml);
          const idValuePairs = [];

          for (const id in hashconfig) {
              if (hashconfig.hasOwnProperty(id)) {
                  const value = hashconfig[id];
                  idValuePairs.push({ id, value });
              }
          }
        

          let arrData=[]
          if(idValuePairs.length>0 && data[index]?.question?.tags.length>0){
              data[index]&&data[index]?.question?.tags?.map(on=>{
                idValuePairs?.map((o)=>{
                    if(on==o?.id){
                      arrData.push(o.value)
                    }
    
                })
              })
          }

          let testarrData=[]
          if(idValuePairs.length>0 &&data[index]?.testQuestion?.tags.length>0){
              data[index]&&data[index]?.testQuestion?.tags?.map(on=>{
                idValuePairs.map(o=>{
                    if(on==o?.id){
                    testarrData.push(o.value)
                    }
    
                })
              })
          }

      


    return (
        <>
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    {/* <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/">QBank</a></li>
                    <li className="breadcrumb-item active">{data ? data.title : ""}</li> */}
                </ul>
            </div>
            {
               data && data[index]?.testQuestion==null && toogleStatus==true &&
            <section className="videoLayer_wrapper qbanks_wrapper testall_attempt_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="topics_wrapper_main">
                            <div className="subjects_wrapper topic_header">
                                <div className="topic_header_content d-flex align-items-center">
                                    <div className="topic_image_ttl d-flex align-items-baseline">
                                            <figure className="back_arrow" onClick={() => navigate(-1)}>
                                                {/* <Link to={`/testlayer/viewallsolution/${id}`}> */}
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                {/* </Link> */}
                                            </figure>
                                        <figure className="subject_inner_img">
                                            <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                            <span className="text_qb">QB</span>
                                        </figure>
                                        <div className="subject_ttl_detail qbanks_ttl_details">
                                            <h5>Bookmark Questions</h5>
                                            {/* <div className="help_wrapper d-flex align-items-center">
                                                <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{data ? data.length : 0} Questions</span></p>
                                                {
                                                  query1.data&&  query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> {query1.data&&query1.data.test.authorDetails ? query1.data.test.authorDetails.name : ""}</p>
                                                }
                                                  {
                                                    !query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> DBMCI Faculty</p>
                                                }
                                            </div> */}
                                            {/* <div className="bookmarks_share">
                                                {
                                                    query1.data&& query1.data.test.progress==null&& 
                                                <span onClick={() => getBookmark({ variables: {  resultId:query1.data.test.progress?query1.data.test.progress._id:"",qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                    <img src={Icons.Bookmark} alt="" className="img-fluid"/> Bookmark Test    
                                                </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                        <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": false } })}>
                                                        <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                <div className="instruction_header d-flex align-items-center">
                                    <div className="attempt_ttl">
                                        <h6> Question {index+1}</h6>
                                    </div>
                                    <div className="ttl_options">
                                        
                                        <span onClick={infoDetailShow}>
                                            <img src={Icons.Info} alt="share" className="img-fluid" />
                                        </span>
                                        {/* {
                                              query1.data&& query1.data.test.progress==null&& 
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                           query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": true} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                            query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject,topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                            </span>
                                        } */}
                                    </div>
                                </div>
                                <div className="instructions_details">
                                    <div className="questions_ttl">
                                        <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                        <div className="ans_img_wrapper">
                                            {
                                                data[index]?.question?.question?.questionImage[0]&&
                                            <img src={data[index]?.question?.question?.questionImage[0].includes('/') ? data[index].question?.question?.questionImage[0] : REACT_APP_ImageURL + data[index]?.question?.question?.questionImage[0]} alt="" className="img-fluid" />
                                            }
                                            {
                                            data[index]?.question?.question?.questionImage[0]&&
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(data[index]?.question?.question?.questionImage[0].includes('/') ? data[index]?.question?.question?.questionImage[0] : REACT_APP_ImageURL + data[index]?.question?.question?.questionImage[0])}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            }
                                        </div>
                                    </div>
                                    <ul type="none" className="instruction_list">
                                        { 
                                                data[index]?.question?.options && data[index]?.question?.options.map((d, i) => (
                                                <>
                                                    <li className={((d._id == ((data[index]?.question?.userAnswer) ? data[index]?.question?.userAnswer : "")) ? (data[index] && data[index]?.question?.answer) == ((data[index]?.question.userAnswer) ? data[index]?.question.userAnswer : "") ? 'correct' : 'wrong' : (data[index]&&data[index]?.question?.answer) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center">
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                    </ul>
                                    {/* {
                                    
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(data[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(data[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                </div>
                            </div>
                            {
                                toogleStatus&&
                                <>
                                    <div className="recommended_video_wrapper answer_details_wrapper">
                                        {
                                            data[index]?.question?.options.map((d, i) => (
                                                data[index]?.userAnswer == d._id &&
                                                <>
                                                    <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                    <h6>{data[index]?.userAnswer == d._id ? d.optionText : ''}</h6>
                                                </>
                                            ))
                                        }
                                        <div className="ans_tags">
                                        {
                                            arrData.map(i=>(
                                                <span>#{i}</span>
                                            ))
                                        }
                                        </div>
                                        <div className="editor_data">
                                            <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                        </div>
                                            {
                                                data[index]?.question?.solution?.solutionImage.map((o)=>(
                                                    <>
                                                 <div className="ans_img_wrapper">
                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            </div>
                                                </>
                                             ))
                                            }
                                       
                                    </div>
                                    {
                                        data[index]?.question?.elements.length != 0 &&
                                        <>
                                        {
                                            data[index]?.question?.elements.map((d, i) => (
                                            <>
                                            {
                                                d.type=="highyeild" &&
                                                <div className="high_yield_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#HighYield</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='extraedge' &&
                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="extraEdge_ttl">
                                                            <h6>#ExtraEdge</h6>
                                                        </div>
                                                        <div className="table-responsive"  dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='table' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Table</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                           
                                            }
                                            {
                                                d.type=='random' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Random</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            </>
                                            ))
                                        }
                                        {/* {
                                            query1.data?.test?.questions[index]?.pearls!==null&&query1.data?.test?.questions[index]?.pearls?.length!==0 &&
                                            <div className="high_yield_wrapper mantra_content_wrapper">
                                                <div className="recommended_video_wrapper">
                                                    <div className="mantra_hedr d-flex justify-content-between align-items-center">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Mantra</h6>
                                                        </div>
                                                        <div className="copy_code">
                                                            <p onClick={() => mantraCopyCode()}>{query1.data?.test&&query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode} <img src={Icons.Copy} alt="" className="img-fluid"/></p>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${query1.data?.test?.questions[index]?.pearls[0]?.description}`}}></div>
                                                </div>
                                            </div>
                                        } */}
                                        </>
                                    }
                                    <div  className="recommended_video_wrapper qid_wrapper">
                                        <h5>Reference</h5>
                                        <p>{data[index]?.question?.reference}</p>
                                    </div>
                                    <div className="recommended_video_wrapper qid_wrapper d-flex align-items-center">
                                        <div className="qid_ttl">
                                            <h6>QID:</h6>
                                        </div>
                                        <div className="qid_code text-center"  >
                                            <ToastContainer />
                                            <span  >{data[index]?.question?.questionCode}</span>
                                            <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => copytext()}  />
                                        </div>
                                    </div>
                            
                                </>
                            }
                         
                             <div className="nexts_prevs_buttons d-flex align-items-center justify-content-between">
                                {
                                    <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                }
                                {
                                    ( index < data.length-1  ) &&
                                    <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            }
            {
               data && data[index]?.question==null && toogleStatus==true &&
            <section className="videoLayer_wrapper qbanks_wrapper testall_attempt_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="topics_wrapper_main">
                            <div className="subjects_wrapper topic_header">
                                <div className="topic_header_content d-flex align-items-center">
                                    <div className="topic_image_ttl d-flex align-items-baseline">
                                            <figure className="back_arrow" onClick={() => navigate(-1)}>
                                                {/* <Link to={`/testlayer/viewallsolution/${id}`}> */}
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                {/* </Link> */}
                                            </figure>
                                        <figure className="subject_inner_img">
                                            <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                            <span className="text_qb">test</span>
                                        </figure>
                                        <div className="subject_ttl_detail qbanks_ttl_details">
                                            <h5>Bookmark Questions</h5>
                                            {/* <div className="help_wrapper d-flex align-items-center">
                                                <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{data ? data.length : 0} Questions</span></p>
                                                {
                                                  query1.data&&  query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> {query1.data&&query1.data.test.authorDetails ? query1.data.test.authorDetails.name : ""}</p>
                                                }
                                                  {
                                                    !query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> DBMCI Faculty</p>
                                                }
                                            </div> */}
                                            {/* <div className="bookmarks_share">
                                                {
                                                    query1.data&& query1.data.test.progress==null&& 
                                                <span onClick={() => getBookmark({ variables: {  resultId:query1.data.test.progress?query1.data.test.progress._id:"",qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                    <img src={Icons.Bookmark} alt="" className="img-fluid"/> Bookmark Test    
                                                </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                        <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": false } })}>
                                                        <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                <div className="instruction_header d-flex align-items-center">
                                    <div className="attempt_ttl">
                                        <h6> Question {index+1}</h6>
                                    </div>
                                    <div className="ttl_options">
                                        
                                        <span onClick={infoDetailShow}>
                                            <img src={Icons.Info} alt="share" className="img-fluid" />
                                        </span>
                                        {/* {
                                              query1.data&& query1.data.test.progress==null&& 
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                           query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": true} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                            query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject,topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                            </span>
                                        } */}
                                    </div>
                                </div>
                                <div className="instructions_details">
                                    <div className="questions_ttl">
                                        <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                        <div className="ans_img_wrapper">
                                            {
                                                 data[index]?.testQuestion?.question?.questionImage[0]&&
                                            <img src={data[index]?.testQuestion?.question?.questionImage[0].includes('/') ? data[index]?.testQuestion?.question?.questionImage[0] : REACT_APP_ImageURL + data[index]?.testQuestion?.question?.questionImage[0]} alt="" className="img-fluid" />
                                            }
                                            {
                                            data[index]?.testQuestion?.question?.questionImage[0]&&
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(data[index]?.testQuestion?.question?.questionImage[0].includes('/') ? data[index]?.testQuestion?.question?.questionImage[0] : REACT_APP_ImageURL + data[index]?.testQuestion?.question?.questionImage[0])}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            }
                                        </div>
                                    </div>
                                    <ul type="none" className="instruction_list">
                                        { 
                                                data[index]?.testQuestion.options && data[index]?.testQuestion.options.map((d, i) => (
                                                <>
                                                    <li className={((d._id == ((data[index]?.testQuestion?.userAnswer) ?data[index]?.testQuestion?.userAnswer : "")) ? (data[index] && data[index]?.testQuestion?.answer) == ((data[index]?.testQuestion?.userAnswer) ? data[index]?.testQuestion?.userAnswer : "") ? 'correct' : 'wrong' : (data[index]&&data[index]?.testQuestion?.answer) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center">
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                    </ul>
                                    {/* {
                                    
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(data[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(data[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                </div>
                            </div>
                            {
                                toogleStatus&&
                                <>
                                    <div className="recommended_video_wrapper answer_details_wrapper">
                                        {
                                            data[index]?.testQuestion?.options.map((d, i) => (
                                                data[index]?.userAnswer == d._id &&
                                                <>
                                                    <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                    <h6>{data[index]?.testQuestion?.answer[0] == d._id ? d?.optionText : ''}</h6>
                                                </>
                                            ))
                                        }
                                        <div className="ans_tags">
                                        {
                                            testarrData.map(i=>(
                                                <span>#{i}</span>
                                            ))
                                        }
                                        </div>
                                        <div className="editor_data">
                                            <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                        </div>
                                            {
                                                data[index]?.testQuestion?.solution?.solutionImage.map((o)=>(
                                                    <>
                                                 <div className="ans_img_wrapper">
                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            </div>
                                                </>
                                             ))
                                            }
                                       
                                    </div>
                                    {
                                        data[index]?.testQuestion?.elements.length != 0 &&
                                        <>
                                        {
                                            data[index]?.testQuestion?.elements.map((d, i) => (
                                            <>
                                            {
                                                d.type=="highyeild" &&
                                                <div className="high_yield_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#HighYield</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='extraedge' &&
                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="extraEdge_ttl">
                                                            <h6>#ExtraEdge</h6>
                                                        </div>
                                                        <div className="table-responsive"  dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='table' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Table</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                           
                                            }
                                            {
                                                d.type=='random' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Random</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            </>
                                            ))
                                        }
                                        {/* {
                                            query1.data?.test?.questions[index]?.pearls!==null&&query1.data?.test?.questions[index]?.pearls?.length!==0 &&
                                            <div className="high_yield_wrapper mantra_content_wrapper">
                                                <div className="recommended_video_wrapper">
                                                    <div className="mantra_hedr d-flex justify-content-between align-items-center">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Mantra</h6>
                                                        </div>
                                                        <div className="copy_code">
                                                            <p onClick={() => mantraCopyCode()}>{query1.data?.test&&query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode} <img src={Icons.Copy} alt="" className="img-fluid"/></p>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${query1.data?.test?.questions[index]?.pearls[0]?.description}`}}></div>
                                                </div>
                                            </div>
                                        } */}
                                        </>
                                    }
                                    <div  className="recommended_video_wrapper qid_wrapper">
                                        <h5>Reference</h5>
                                        <p>{data[index]?.testQuestion?.reference}</p>
                                    </div>
                                    <div className="recommended_video_wrapper qid_wrapper d-flex align-items-center">
                                        <div className="qid_ttl">
                                            <h6>QID:</h6>
                                        </div>
                                        <div className="qid_code text-center"  >
                                            <ToastContainer />
                                            <span  >{data[index]?.testQuestion?.questionCode}</span>
                                            <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => testcopytext()}  />
                                        </div>
                                    </div>
                            
                                </>
                            }
                         
                             <div className="nexts_prevs_buttons d-flex align-items-center justify-content-between">
                                {
                                    <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                }
                                {
                                    ( index < data.length-1  ) &&
                                    <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            }
            {
                data[index]?.testQuestion==null && toogleStatus==false &&
            <section className="videoLayer_wrapper qbanks_wrapper testall_attempt_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="topics_wrapper_main">
                            <div className="subjects_wrapper topic_header">
                                <div className="topic_header_content d-flex align-items-center">
                                    <div className="topic_image_ttl d-flex align-items-baseline">
                                            <figure className="back_arrow" onClick={() => backArrowSubmit()}>
                                                {/* <Link to={`/testlayer/viewallsolution/${id}`}> */}
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                {/* </Link> */}
                                            </figure>
                                        <figure className="subject_inner_img">
                                            <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                            <span className="text_qb">QB</span>
                                        </figure>
                                        <div className="subject_ttl_detail qbanks_ttl_details">
                                            <h5>Bookmark Questions</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                <div className="instruction_header d-flex align-items-center">
                                    <div className="attempt_ttl">
                                        <h6> Question {index+1}</h6>
                                    </div>
                                    <div className="ttl_options">  
                                        <span onClick={infoDetailShow}>
                                            <img src={Icons.Info} alt="share" className="img-fluid" />
                                        </span>
                                    </div>
                                </div>
                                <div className="instructions_details">
                                    <div className="questions_ttl">
                                        <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                        <div className="ans_img_wrapper">
                                            {
                                                data[index]?.question?.question?.questionImage[0]&&
                                            <img src={data[index]?.question?.question?.questionImage[0]?.includes('/') ?data[index]?.question?.question?.questionImage[0]:REACT_APP_ImageURL +data[index]?.question?.question?.questionImage[0]} alt="" className="img-fluid" />
                                            }
                                            {
                                            data[index]?.question?.question?.questionImage[0]&&
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(data[index]?.question?.question?.questionImage[0]?.includes('/') ?data[index]?.question?.question?.questionImage[0]:REACT_APP_ImageURL +data[index]?.question?.question?.questionImage[0])}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            }
                                        </div>
                                    </div>
                                    <ul type="none" className="instruction_list">
                                        { 
                                         localAttemtedQuestions[index]!==undefined && localAttemtedQuestions[index]?.isReview==true &&
                                                data[index]?.question?.options && data[index]?.question?.options.map((d, i) => (
                                                <>
                                                    <li className={((d._id == ((localAttemtedQuestions[index]?.userAnswer) ? localAttemtedQuestions[index]?.userAnswer : "")) ? (localAttemtedQuestions[index] && localAttemtedQuestions[index]?.answer) == ((localAttemtedQuestions[index]?.userAnswer) ? localAttemtedQuestions[index]?.userAnswer : "") ? 'correct' : 'wrong' : (localAttemtedQuestions[index]&&localAttemtedQuestions[index]?.answer) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center">
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                              
                                             { 
                                              localAttemtedQuestions[index]===undefined && 
                                                data[index]?.question?.options && data[index]?.question?.options.map((d, i) => (
                                                <>
                                                    <li>
                                                        <div className="ins_list_content d-flex align-items-center" onClick={(e) => selectedAnswer(d._id, data[index]?.question._id,data[index]?.question.answer, true)}>
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                    </ul>
                                    {/* {
                                    
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(data[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(data[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                </div>
                            </div>
                            {
                               localAttemtedQuestions[index]!== undefined && 
                                <>
                                    <div className="recommended_video_wrapper answer_details_wrapper">
                                        {
                                            data[index]?.question?.options.map((d, i) => (
                                                data[index]?.userAnswer == d._id &&
                                                <>
                                                    <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                    <h6>{data[index]?.userAnswer == d._id ? d.optionText : ''}</h6>
                                                </>
                                            ))
                                        }
                                        <div className="ans_tags">
                                        {
                                            arrData.map(i=>(
                                                <span>#{i}</span>
                                            ))
                                        }
                                        </div>
                                        <div className="editor_data">
                                            <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                        </div>
                                            {
                                                data[index]?.question?.solution?.solutionImage.map((o)=>(
                                                    <>
                                            <div className="ans_img_wrapper">
                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            </div>
                                                </>
                                             ))
                                            }
                                       
                                    </div>
                                    {
                                        data[index]?.question?.elements.length != 0 &&
                                        <>
                                        {
                                            data[index]?.question?.elements.map((d, i) => (
                                            <>
                                            {
                                                d.type=="highyeild" &&
                                                <div className="high_yield_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#HighYield</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='extraedge' &&
                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="extraEdge_ttl">
                                                            <h6>#ExtraEdge</h6>
                                                        </div>
                                                        <div className="table-responsive"  dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='table' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Table</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                           
                                            }
                                            {
                                                d.type=='random' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Random</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            </>
                                            ))
                                        }
                                        {/* {
                                            query1.data?.test?.questions[index]?.pearls!==null&&query1.data?.test?.questions[index]?.pearls?.length!==0 &&
                                            <div className="high_yield_wrapper mantra_content_wrapper">
                                                <div className="recommended_video_wrapper">
                                                    <div className="mantra_hedr d-flex justify-content-between align-items-center">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Mantra</h6>
                                                        </div>
                                                        <div className="copy_code">
                                                            <p onClick={() => mantraCopyCode()}>{query1.data?.test&&query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode} <img src={Icons.Copy} alt="" className="img-fluid"/></p>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${query1.data?.test?.questions[index]?.pearls[0]?.description}`}}></div>
                                                </div>
                                            </div>
                                        } */}
                                        </>
                                    }
                                    <div  className="recommended_video_wrapper qid_wrapper">
                                        <h5>Reference</h5>
                                        <p>{data[index]?.question?.reference}</p>
                                    </div>
                                    <div className="recommended_video_wrapper qid_wrapper d-flex align-items-center">
                                        <div className="qid_ttl">
                                            <h6>QID:</h6>
                                        </div>
                                        <div className="qid_code text-center"  >
                                            <ToastContainer />
                                            <span  >{data[index]?.question?.questionCode}</span>
                                            <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => copytext()}  />
                                        </div>
                                    </div>
                            
                                </>
                            }
                         
                             <div className="nexts_prevs_buttons d-flex align-items-center justify-content-between">
                                {
                                    <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                }
                                {
                                    ( index < data.length-1  ) &&
                                    <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            }
            {
                data[index]?.question==null && toogleStatus==false &&
            <section className="videoLayer_wrapper qbanks_wrapper testall_attempt_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="topics_wrapper_main">
                            <div className="subjects_wrapper topic_header">
                                <div className="topic_header_content d-flex align-items-center">
                                    <div className="topic_image_ttl d-flex align-items-baseline">
                                            <figure className="back_arrow" onClick={() => backArrowSubmit()}>
                                                {/* <Link to={`/testlayer/viewallsolution/${id}`}> */}
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                {/* </Link> */}
                                            </figure>
                                        <figure className="subject_inner_img">
                                            <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                            <span className="text_qb">test</span>
                                        </figure>
                                        <div className="subject_ttl_detail qbanks_ttl_details">
                                            <h5>Bookmark Questions</h5>
                                            {/* <div className="help_wrapper d-flex align-items-center">
                                                <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{data ? data.length : 0} Questions</span></p>
                                                {
                                                  query1.data&&  query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> {query1.data&&query1.data.test.authorDetails ? query1.data.test.authorDetails.name : ""}</p>
                                                }
                                                  {
                                                    !query1.data.test.authorDetails&&
                                                <p><span>Verified by</span> DBMCI Faculty</p>
                                                }
                                            </div> */}
                                            {/* <div className="bookmarks_share">
                                                {
                                                    query1.data&& query1.data.test.progress==null&& 
                                                <span onClick={() => getBookmark({ variables: {  resultId:query1.data.test.progress?query1.data.test.progress._id:"",qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                    <img src={Icons.Bookmark} alt="" className="img-fluid"/> Bookmark Test    
                                                </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true } })}>
                                                        <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                {
                                                   query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                                    <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": false } })}>
                                                        <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark Test
                                                    </span>
                                                }
                                                
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                <div className="instruction_header d-flex align-items-center">
                                    <div className="attempt_ttl">
                                        <h6> Question {index+1}</h6>
                                    </div>
                                    <div className="ttl_options">
                                        
                                        <span onClick={infoDetailShow}>
                                            <img src={Icons.Info} alt="share" className="img-fluid" />
                                        </span>
                                        {/* {
                                              query1.data&& query1.data.test.progress==null&& 
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                           query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject, topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": true} })}>
                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                            </span>
                                        }
                                        {
                                            query1.data&& query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                            <span onClick={() => getBookmarkQuestion({ variables: { qbId: query1.data.test._id, resultType: "Test", questionId: data[index]._id, subjectId: query1.data.test.subject,topicId :data[index].topic ?data[index].topic:null,courseName: course.preparingFor, "status": false} })}>
                                                <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                            </span>
                                        } */}
                                    </div>
                                </div>
                                <div className="instructions_details">
                                    <div className="questions_ttl">
                                        <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                        <div className="ans_img_wrapper">
                                            {
                                                 data[index]?.testQuestion?.question?.questionImage[0]&&
                                            <img src={data[index]?.testQuestion?.question?.questionImage[0]?.includes('/') ?data[index]?.testQuestion?.question?.questionImage[0]:REACT_APP_ImageURL +data[index]?.testQuestion?.question?.questionImage[0]} alt="" className="img-fluid" />
                                            }
                                            {
                                            data[index]?.testQuestion?.question?.questionImage[0]&&
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(data[index]?.testQuestion?.question?.questionImage[0]?.includes('/') ?data[index]?.testQuestion?.question?.questionImage[0]:REACT_APP_ImageURL +data[index]?.testQuestion?.question?.questionImage[0])}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            }
                                        </div>
                                    </div>
                                    <ul type="none" className="instruction_list">
                                        { 
                                         localAttemtedQuestions[index]!==undefined &&
                                                data[index]?.testQuestion.options && data[index]?.testQuestion.options.map((d, i) => (
                                                <>
                                                    <li className={((d._id == ((localAttemtedQuestions[index]?.userAnswer) ? localAttemtedQuestions[index]?.userAnswer : "")) ? (localAttemtedQuestions[index] && localAttemtedQuestions[index]?.answer) == ((localAttemtedQuestions[index]?.userAnswer) ? localAttemtedQuestions[index]?.userAnswer : "") ? 'correct' : 'wrong' : (localAttemtedQuestions[index]&&localAttemtedQuestions[index]?.answer) == d._id ? 'correct' : '')}>
                                                        <div className="ins_list_content d-flex align-items-center" >
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                             
                                            { 
                                             localAttemtedQuestions[index]===undefined  &&
                                                data[index]?.testQuestion.options && data[index]?.testQuestion.options.map((d, i) => (
                                                <>
                                                    <li >
                                                        <div className="ins_list_content d-flex align-items-center" onClick={() => selectedAnswer(d._id, data[index]?.testQuestion._id,data[index]?.testQuestion.answer, true)}>
                                                            <div className="ques_attempt_body">
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
    
                                                            </div>
                                                           
                                                        </div>
                                                    </li>
                                                </>
                                            ))
                                            }
                                    </ul>
                                    {/* {
                                    
                                        <div className="ques_progress">
                                            <p><span>{`${getQbProgressPercentage(data[index])}`}%</span> of the people got this right</p>
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: `${getQbProgressPercentage(data[index])}%`}}></div>
                                            </div>
                                        </div>
                                    } */}
                                </div>
                            </div>
                            {
                                localAttemtedQuestions[index]!==undefined && 
                                <>
                                    <div className="recommended_video_wrapper answer_details_wrapper">
                                        {
                                            data[index]?.testQuestion?.options.map((d, i) => (
                                                data[index]?.userAnswer == d._id &&
                                                <>
                                                    <p>Answer. <span>({String.fromCharCode(65 + i)})</span></p>
                                                    <h6>{data[index]?.testQuestion?.answer[0] == d._id ? d?.optionText : ''}</h6>
                                                </>
                                            ))
                                        }
                                        <div className="ans_tags">
                                        {
                                            testarrData.map(i=>(
                                                <span>#{i}</span>
                                            ))
                                        }
                                        </div>
                                        <div className="editor_data">
                                            <p dangerouslySetInnerHTML={{ __html: solutionmodifiedHtml }}></p>
                                        </div>
                                            {
                                                data[index]?.testQuestion?.solution?.solutionImage.map((o)=>(
                                                    <>
                                                 <div className="ans_img_wrapper">
                                            <img src={o.includes('/') ? o : REACT_APP_ImageURL + o} alt="" className="img-fluid" />
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(o.includes('/') ? o : REACT_APP_ImageURL + o)}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            </div>
                                                </>
                                             ))
                                            }
                                       
                                    </div>
                                    {
                                        data[index]?.testQuestion?.elements.length != 0 &&
                                        <>
                                        {
                                            data[index]?.testQuestion?.elements.map((d, i) => (
                                            <>
                                            {
                                                d.type=="highyeild" &&
                                                <div className="high_yield_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#HighYield</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='extraedge' &&
                                                <div className="high_yield_wrapper extraEdge_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="extraEdge_ttl">
                                                            <h6>#ExtraEdge</h6>
                                                        </div>
                                                        <div className="table-responsive"  dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                d.type=='table' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Table</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                           
                                            }
                                            {
                                                d.type=='random' &&
                                                <div className="high_yield_wrapper table_content_wrapper">
                                                    <div className="recommended_video_wrapper">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Random</h6>
                                                        </div>
                                                        <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${d?d.data:""}`}}></div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            </>
                                            ))
                                        }
                                        {/* {
                                            query1.data?.test?.questions[index]?.pearls!==null&&query1.data?.test?.questions[index]?.pearls?.length!==0 &&
                                            <div className="high_yield_wrapper mantra_content_wrapper">
                                                <div className="recommended_video_wrapper">
                                                    <div className="mantra_hedr d-flex justify-content-between align-items-center">
                                                        <div className="high_yield_ttl">
                                                            <h6>#Mantra</h6>
                                                        </div>
                                                        <div className="copy_code">
                                                            <p onClick={() => mantraCopyCode()}>{query1.data?.test&&query1.data?.test?.questions[index]?.pearls[0]?.pearlsCode} <img src={Icons.Copy} alt="" className="img-fluid"/></p>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive" dangerouslySetInnerHTML={{__html: `${query1.data?.test?.questions[index]?.pearls[0]?.description}`}}></div>
                                                </div>
                                            </div>
                                        } */}
                                        </>
                                    }
                                    <div  className="recommended_video_wrapper qid_wrapper">
                                        <h5>Reference</h5>
                                        <p>{data[index]?.testQuestion?.reference}</p>
                                    </div>
                                    <div className="recommended_video_wrapper qid_wrapper d-flex align-items-center">
                                        <div className="qid_ttl">
                                            <h6>QID:</h6>
                                        </div>
                                        <div className="qid_code text-center"  >
                                            <ToastContainer />
                                            <span  >{data[index]?.testQuestion?.questionCode}</span>
                                            <img src={Icons.Copy} alt="" className="img-fluid" onClick={() => testcopytext()}  />
                                        </div>
                                    </div>
                            
                                </>
                            }
                         
                             <div className="nexts_prevs_buttons d-flex align-items-center justify-content-between">
                                {
                                    <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                }
                                {
                                    ( index < data.length-1  ) &&
                                    <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            }
        </div>

        <Modal
        show={infoShow}
        onHide={infoDetailhide}
        backdrop="static"
        className="detail_modal report_modal"
        centered
        >
                <ToastContainer />
        <form action=""  onSubmit={(e) => { handleSubmit(e) }}>
        <Modal.Header>
            <Modal.Title>
                <h4>Report Issue</h4>
                <span className="cross_icon">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={infoDetailhide}/>
                </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="rating_modal_body">
                    <div className="form-group">
                        <label htmlFor="">Issue Type</label>
                        <select name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'category')} value={getDetails.category ?? ''}>
                        <option value=''>Please Select</option>
                        {
                            config&&config?.qb_question?.categories?.map((d, i) => (
                                <option value={d.category_name}>{d.category_name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Description</label>
                        <textarea name="" id="" rows="5" className="form-control" placeholder="Please add issue description here..." onChange={(e) => handleInputChange(e.target.value, 'userFeedBack')} value={getDetails.userFeedBack ?? ''}></textarea>
                    </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <div className="rating_submit">
                <button type="button" className="btn btn_theme btn_border" onClick={infoDetailhide}>Cancel</button>
                <button type="submit" disabled={enable} className="btn btn_theme" >Submit</button>
            </div>
        </Modal.Footer>
                </form>
        </Modal>
        <Modal 
            show={imgPopup}
            onHide={imgHide}
            backdrop="static"
            className="detail_modal modelImgPopup"
            centered
            size="lg"
            >
            <Modal.Body>
                <div className="Img_wrapper">
                    <span className="cross_icon">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={imgHide}/>
                    </span>
                    <div className="img_popup">
                        <img src={showImg} alt="Popup Image" />
                    </div>
                </div>
            </Modal.Body>
            </Modal>
        </>
    ) 
}